import React, { useCallback, useContext } from 'react'
import cn from 'classnames'
import { Button, ButtonStyles } from '@grammarly/badger-ui'
import styles from './tool-suite.module.scss'
import { Tool } from './tool-suite-content'
import { usePlacementContext } from '../../../contexts/placement-context'
import { trackGA4BtnClick } from '../../../lib/tracking/google-tag-manager/events'
import { waitGnar } from '../../../lib/utils/promise'
import { gnarSpec } from '../../../lib/tracking/gnar'
import { navHelper } from '../../../lib/services/navigation'
import { PageContext } from '../../../contexts/page-context'
import { getConfig } from '../../../config'

const baseUrl = getConfig().urls.main

type ToolCTAProps = Tool

export const ToolCTA: React.FC<ToolCTAProps> = ({ text, icon, name, slug }) => {
  const { placement, placementInternalName } = usePlacementContext()
  const { pageId, slug: pageSlug } = useContext(PageContext)
  const targetUrl = `${baseUrl}/${slug}`

  const onClick = useCallback(async () => {
    trackGA4BtnClick(placement)
    await waitGnar(
      gnarSpec.customLinkCtaButtonClick(name, pageId, pageSlug, targetUrl, placement, placementInternalName)
    )

    navHelper.navigateUrl(targetUrl, navHelper.currentQueryParams)
  }, [placement, name, pageId, pageSlug, targetUrl, placementInternalName])

  return (
    <Button
      className={cn(ButtonStyles.GreyButtonBlueText, styles.cta)}
      iconLeft={icon}
      as="a"
      href={targetUrl}
      padding="cta"
      onClick={onClick}
    >
      {text}
    </Button>
  )
}
